import { Divider, Tooltip } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import Button from 'components/new-ui/base/button/Button';
import PopoverButtonsGroup from 'components/new-ui/composed/popover-buttons-group/PopoverButtonsGroup';
import { StyledPopoverButton } from 'components/new-ui/composed/popover-buttons-group/styles';

type Props = {
    open: boolean;
    disabled?: boolean;
    editManifestDisabled?: boolean;
    editManifestTooltip?: string;
    onOpenChange: (open: boolean) => void;
    onEditManifest?: () => void;
    onCreateEns?: () => void;
};

const ManifestActionsPopover = ({
    open,
    disabled,
    onOpenChange,
    onEditManifest,
    editManifestDisabled,
    editManifestTooltip,
    onCreateEns,
}: Props) => {
    const runAndClose = (action: () => void) => () => {
        onOpenChange(false);
        action();
    };

    return (
        <PopoverButtonsGroup
            open={open}
            onOpenChange={onOpenChange}
            buttonEl={<Button disabled={disabled} icon={<MoreOutlined />} />}
        >
            {onEditManifest && (
                <Tooltip title={editManifestTooltip} placement="left">
                    <span>
                        <StyledPopoverButton disabled={editManifestDisabled} onClick={runAndClose(onEditManifest)}>
                            Edit Manifest
                        </StyledPopoverButton>
                    </span>
                </Tooltip>
            )}

            {onEditManifest && onCreateEns && <Divider style={{ margin: '4px 0', borderColor: 'var(--gray-4)' }} />}

            {onCreateEns && <StyledPopoverButton onClick={runAndClose(onCreateEns)}>Create ENS</StyledPopoverButton>}
        </PopoverButtonsGroup>
    );
};

export default ManifestActionsPopover;
